import TabImage from './TabImage';
import Footer from './Footer';
import BackgroundImages from './BackgroundImage';

//Groups

export {
	TabImage, Footer, BackgroundImages
};
